import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_2 = { class: "lg:col-span-2" }
const _hoisted_3 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_4 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "bg-yellow-100 text-yellow-800 px-3 py-1 rounded text-xs"
}
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_8 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded mb-4"
}
const _hoisted_9 = {
  key: 2,
  class: "sm:grid sm:grid-cols-2 sm:gap-[25px]"
}
const _hoisted_10 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "mb-[20px] sm:mb-0"
}
const _hoisted_29 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_30 = { class: "flex items-center gap-4" }
const _hoisted_31 = {
  key: 0,
  class: "w-24 h-24 rounded overflow-hidden"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  id: "fileUploader"
}
const _hoisted_34 = {
  key: 0,
  class: "flex justify-end mt-6"
}
const _hoisted_35 = { class: "lg:col-span-1" }
const _hoisted_36 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_37 = { class: "trezo-card-content" }
const _hoisted_38 = { class: "mb-[20px] md:mb-[25px] last:mb-0" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "flex flex-wrap gap-2 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Edit Product")
            ], -1)),
            (_ctx.isExternalProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " External product - Read only "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[13] || (_cache[13] = [
                  _createElementVNode("div", { class: "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent" }, null, -1)
                ])))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Product Title ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.title) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_11), [
                        [_vModelText, _ctx.product.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Product Type ", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.product_type) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, _cache[15] || (_cache[15] = [
                        _createElementVNode("option", { value: "" }, "Select", -1),
                        _createElementVNode("option", { value: "Digital Product" }, "Digital Product", -1),
                        _createElementVNode("option", { value: "Physical Product" }, "Physical Product", -1)
                      ]), 8, _hoisted_13), [
                        [_vModelSelect, _ctx.product.product_type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " SKU ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.sku) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_15), [
                        [_vModelText, _ctx.product.sku]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Category ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.category) = $event)),
                        placeholder: "Enter category",
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_17), [
                        [_vModelText, _ctx.product.category]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Product Description ", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.description) = $event)),
                        class: "h-[179px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_19), [
                        [_vModelText, _ctx.product.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Regular Price ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.price) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_21), [
                        [_vModelText, _ctx.product.price]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Sale Price ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.compare_at_price) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_23), [
                        [_vModelText, _ctx.product.compare_at_price]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Product Link ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.product_link) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_25), [
                        [_vModelText, _ctx.product.product_link]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Publish Date ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.product.publish_date) = $event)),
                        disabled: _ctx.isExternalProduct
                      }, null, 8, _hoisted_27), [
                        [_vModelText, _ctx.product.publish_date]
                      ])
                    ]),
                    (!_ctx.isExternalProduct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Meeting Time (minutes) ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.product.time) = $event)),
                            placeholder: "Enter meeting duration in minutes"
                          }, null, 512), [
                            [_vModelText, _ctx.product.time]
                          ]),
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 mt-1 block" }, " Specify the meeting duration in minutes ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Product Image ", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.product.image_link)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("img", {
                                src: _ctx.product.image_link,
                                alt: "Product image",
                                class: "w-full h-full object-cover"
                              }, null, 8, _hoisted_32)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isExternalProduct)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[26] || (_cache[26] = [
                              _createStaticVNode("<div class=\"relative flex items-center justify-center overflow-hidden rounded-md py-4 px-[20px] border border-gray-200 dark:border-[#172036]\"><div class=\"flex items-center justify-center\"><div class=\"w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]\"><i class=\"ri-upload-2-line\"></i></div><p class=\"leading-[1.5]\"><strong class=\"text-black dark:text-white\">Click to upload</strong><br> new image </p></div><input type=\"file\" id=\"fileInput\" class=\"absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer\"></div>", 1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
          ]),
          (!_ctx.loading && !_ctx.error && !_ctx.isExternalProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveProduct && _ctx.saveProduct(...args)))
                }, " Save Changes ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
            _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Tags")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "mb-[10px] text-black dark:text-white font-medium block" }, " Tags ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                placeholder: "Enter tags separated by commas",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tagsInput) = $event)),
                disabled: _ctx.isExternalProduct
              }, null, 8, _hoisted_39), [
                [_vModelText, _ctx.tagsInput]
              ]),
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedTags, (tag, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-sm"
                  }, _toDisplayString(tag), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}